import React, { useState } from 'react'
import Portal from 'components/Portal/Portal'
import { Modal } from 'components/Modal/Modal'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { Spinner } from 'components/Loaders/Loaders'
import { SEND_PASSWORD_RESET_EMAIL } from '../../../requests'
import { useDispatch } from 'react-redux'
import { setSuccessToast } from '../../../actions'

const ResetPassword = ({ email, showResetPasswordConfirm, setShowResetPasswordConfirm }) => {
  const dispatch = useDispatch()
  const [isSending, setIsSending] = useState(false)
  const [sendError, setSendError] = useState('')

  const closeModal = () => {
    console.log(email)
    setShowResetPasswordConfirm(false)
    setSendError('')
  }

  const sendResetEmail = () => {
    if (isSending) return
    setIsSending(true)
    setSendError('')
    SEND_PASSWORD_RESET_EMAIL(
      { userId: email },
      () => {
        setIsSending(false)
        setShowResetPasswordConfirm(false)
        dispatch(setSuccessToast('Password reset email sent successfully.'))
      },
      () => {
        setIsSending(false)
        setSendError('Something went wrong sending the email, please try again later.')
      }
    )
  }

  return (
    <Portal isOpened={showResetPasswordConfirm}>
      <Modal
        title="Confirm Password Reset"
        autoHeight
        modalSize="medium"
        closeModal={closeModal}
      >
        <div className="change-password-modal">
          <p>An email will be sent to {email} allowing them to reset their password.</p>
          {sendError && <p className="field-error" style={{ textAlign: 'center' }}>{sendError}</p>}
          <div className="context-buttons">
            <ContextButton variant="secondary" onClick={closeModal}>
              Cancel
            </ContextButton>
            <ContextButton variant="primary" onClick={sendResetEmail}>
              {isSending ? <Spinner size="small" themeColor="dark-neutral" /> : 'OK'}
            </ContextButton>
          </div>
        </div>
      </Modal>
    </Portal>
  )
}

export default ResetPassword
